import {AlertReportType} from './alert-report-type.enum';
import {AlertReportFilter} from './alert-report-filter.model';
import {AlertMetric} from './alert-metric.enum';
export class AlertRequest {
  metrics: AlertMetric[] = [];
  reportType: AlertReportType;
  reportTypes: AlertReportType[] = [];
  filter: AlertReportFilter = new AlertReportFilter();
  groupingType: AlertGroupingType = AlertGroupingType.ALERT_UNIT;
}

export enum AlertGroupingType{
  ALERT = 'ALERT',
  ALERT_UNIT = 'ALERT_UNIT'
}
